import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import Loading from 'components/loading';
import Routes from './routes';
import withClientId from 'hocs/with-client-id';
import { getClient } from 'redux/modules/model/client';
import { userSelector } from 'redux/selectors';
import { reauthenticateRequest, setInitialized } from 'redux/modules/user';
import { MFA_SETTINGS } from '../config/routes';

class Main extends Component {
	state = {
		user: {},
	};

	componentWillMount() {
		const {
			clientId,
			getClient,
			reauthenticateRequest,
			setInitialized,
			user: { currentUser },
		} = this.props;

		this.setState(
			{
				user: currentUser,
			},
			function() {},
		);

		// Reauthenticate if we have a session.
		getClient({ clientId });
		if (currentUser && currentUser.token) {
			reauthenticateRequest({
				clientId,
				sessionToken: currentUser.token,
			});
		} else {
			setInitialized();
		}

		const { history } = this.props;

		history.listen(location => {
			const {
				user: { currentUser },
			} = this.props;

			if (currentUser) {
				let { operator } = currentUser;
				if (
					operator.isMFAEnabledByClient &&
					!operator.isMFAEnabledByOperator &&
					location.pathname !== MFA_SETTINGS
				) {
					history.push(MFA_SETTINGS);
				}
			}
		});
	}

	render() {
		const { user, history } = this.props;
		return user.initialising ? <Loading /> : <Routes history={history} />;
	}
}

const selector = createStructuredSelector({
	user: userSelector,
});

const actions = {
	getClient,
	reauthenticateRequest,
	setInitialized,
};

export default compose(withClientId, connect(selector, actions))(Main);



// WEBPACK FOOTER //
// ./src/main/index.js